import axios from "axios";
import authHeader from "./auth-header";
import authFileHeader from "./auth-header";
const fileExt = '.wav';

class UserService {
  getDocuments() {
    return axios.get(process.env.VUE_APP_ROOT + "/documents.json", { headers: authHeader() });
  }
  getLanguages(v2v = false) {
    // return axios.get(process.env.VUE_APP_ROOT + "/languages.json", {
    //   headers: {
    //     'Authorization': authHeader().Authorization,
    //     'Content-Type': 'application/json',
    //   }
    // });
    const myData = new FormData();
    myData.append('v2v', v2v);
    return axios({
      method: "post",
      url: process.env.VUE_APP_ROOT + "/languages.json",
      data: myData,
      headers: authFileHeader(),
    });
  }
  getCountryLanguages(id = null){
    if(!id)
      return axios.get(process.env.VUE_APP_ROOT + "/languages/country.json", {headers: {
        'Authorization': authHeader().Authorization,
        'Content-Type': 'application/json',
      } });
    else
      return axios.get(process.env.VUE_APP_ROOT + "/languages/country/"+id+".json", {headers: {
        'Authorization': authHeader().Authorization,
        'Content-Type': 'application/json',
      } });
  }
  getTextToSpeech(){
    return axios.post(process.env.VUE_APP_ROOT + "languages/textToSpeech", {headers: {
      'Authorization': authHeader().Authorization,
      'Content-Type': 'application/json',
    } });
  }
  contattami(form){
    const myData = new FormData();
    myData.append('from', form.from);
    myData.append('to', form.to);
    myData.append('oggetto', form.oggetto);
    myData.append('testo', form.testo);

    return axios({
      method: "post",
      url: process.env.VUE_APP_ROOT + "/users/contattami",
      data: myData,
      headers: authFileHeader(),
    });
  }
  getUser(user_id) {
    return axios.get(process.env.VUE_APP_ROOT + "/users/translatorCard/" + user_id + ".json", {
      headers: authHeader(),
    });
  }
  getOrganizationsList() {
    return axios.get(process.env.VUE_APP_ROOT + "/organizations/list.json", { headers: authHeader() });
  }
  getOrganizations() {
    return axios.get(process.env.VUE_APP_ROOT + "/organizations/index.json", { headers: authHeader() });
  }
  getOrganizationById(id) {
    return axios.get(process.env.VUE_APP_ROOT + "/organizations/find/"+id+".json", { headers: authHeader() });
  }
  getStatus() {
    return axios.get(process.env.VUE_APP_ROOT + "/status.json", { headers: authHeader() });
  }
  getTranslators(qstring) {
    qstring = qstring ? qstring+='&public' : qstring+='?public';
    return axios.get(process.env.VUE_APP_ROOT + `/users/translators.json${qstring}`, { headers: authHeader() });
  }

  getReviewerComplete() {
    return axios.get(process.env.VUE_APP_ROOT + "/documents/reviewer/complete.json", { headers: authHeader() });
  }
  getReviewerPending() {
    return axios.get(process.env.VUE_APP_ROOT + "/documents/reviewer/pending.json", { headers: authHeader() });
  }
  getReviewerRequest() {
    return axios.get(process.env.VUE_APP_ROOT + "/documents/reviewer/request.json", { headers: authHeader() });
  }

  getRequesterComplete() {
    return axios.get(process.env.VUE_APP_ROOT + "/documents/requester/complete.json", { headers: authHeader() });
  }
  getRequesterPending() {
    return axios.get(process.env.VUE_APP_ROOT + "/documents/requester/pending.json", { headers: authHeader() });
  }
  getRequesterRequest() {
    return axios.get(process.env.VUE_APP_ROOT + "/documents/requester/request.json", { headers: authHeader() });
  }
  getArchivio(qstring) {
    return axios.get(process.env.VUE_APP_ROOT + `/documents/requester/archivio.json${qstring}`, { headers: authHeader() });
  }
  getSrcLanguages(qstring){
    return axios.get(process.env.VUE_APP_ROOT + `/documents/languages/src.json${qstring}`, { headers: authHeader() });
  }
  getDestLanguages(qstring){
    return axios.get(process.env.VUE_APP_ROOT + `/documents/languages/dest.json${qstring}`, { headers: authHeader() });
  }
  getRequesterQueue() {
    return axios.get(process.env.VUE_APP_ROOT + "/documents/requester/queue.json", { headers: authHeader() });
  }
  uploadAudio(lang1, lang2, id, time, msg, i) {
    const myData = new FormData();
    //myData.append("reviewed", msg, lang1+"_to_"+lang2+"-"+time+".mp3");
    myData.append("reviewed", msg, i+"-source_"+lang1+"-"+time+fileExt);
    myData.append('src', lang1);
    myData.append('dest', lang2);
    myData.append('i', i);

    return axios({
      method: "post",
      url: process.env.VUE_APP_ROOT + "/languages/audio/upload/"+id,
      data: myData,
      headers: authFileHeader(),
    });
  }
  textToSpeech(id, sendRequest){

    const requestOptions = {
     method: "POST",
     headers: {
       'Authorization': authHeader().Authorization,
       'Content-Type': 'application/json',
    },
     body: JSON.stringify({
       langIn: 'it',
       langOut: id,
       inText: 'è questa la tua lingua?',
       sendRequest: sendRequest?sendRequest:'no',
     })
    };
    return fetch(process.env.VUE_APP_ROOT+"/languages/textToSpeech", requestOptions);
  }
  textToText(idIn,idOut, save = 'save', text = undefined){
    const requestOptions = {
      method: "POST",
      headers: {
        'Authorization': authHeader().Authorization,
        'Content-Type': 'application/json',
     },
      body: JSON.stringify({
        langIn: idIn,
        langOut: idOut,
        inText: text?text:'è questa la tua lingua?',
        save: save,
      })
     };
     return fetch(process.env.VUE_APP_ROOT+"/languages/textToText", requestOptions);
  }
  removeAudio(id){
    return axios({
      method: "post",
      url: process.env.VUE_APP_ROOT + "/languages/audio/remove/"+id,
      headers: authFileHeader(),
    });
  }
  getAudio(path=null, id){
    if(!(id == null))
      path=path+'//'+id.id+'.wav';
    else
      path='//tmp//'+path;

    const requestOptions = {
     method: "POST",
     headers: {
       'Authorization': authHeader().Authorization,
       'Content-Type': 'application/json',
    },
     body: JSON.stringify({path: path})
    };
    console.log(path);
    return fetch(process.env.VUE_APP_ROOT+"/languages/getAudio", requestOptions);

  }
  editUser(user_id, myForm) {
    return axios({
      method: "post",
      url: `${process.env.VUE_APP_ROOT}/users/edit/${user_id}.json`,
      data: myForm,
      headers: authFileHeader(),
    });
  }
  addOrganization(organization) {
    const pData = new FormData();
    console.log(organization);
    pData.append("name", organization.name);
    if(organization.parent_id)
      pData.append("parent_id", organization.parent_id);
    pData.append("address", organization.address);
    pData.append("city", organization.city);
    pData.append("province", organization.province);
    pData.append("email", organization.email);
    if(organization.web)
      pData.append("web", organization.web);
    pData.append("ref_person", organization.ref_person);
    pData.append("ref_email", organization.ref_email);
    pData.append("ref_phone", organization.ref_phone);
    return axios.post(process.env.VUE_APP_ROOT + "/organizations/add.json", pData);
  }
  /*
  addOrganization(payload) {
    var myForm = new FormData();
    //myForm.append("organization", payload);
    return axios({
      method: "post",
      data: myForm.payload,
      url: `${process.env.VUE_APP_ROOT}/organizations/add.json`,
      //headers: authFileHeader(),
    });
  }
  addOrganization_(payload) {
    return axios.post(process.env.VUE_APP_ROOT + "/organizations/add.json", payload).then((response) => {
      if (response.data) {
        console.log('Ewquest is ok')
      }
    })
  }
  */

  takeCharge(document_id) {
    return axios.get(process.env.VUE_APP_ROOT + "/documents/requester/takeCharge/" + document_id, {
      headers: authHeader(),
    });
  }

  whoAmI() {
    return axios.get(process.env.VUE_APP_ROOT + "/users/whoami.json", {
      headers: authHeader(),
    });
  }

  uploadDoc(document_id, file) {
    var myForm = new FormData();
    myForm.append("reviewed", file);

    return axios({
      method: "post",
      url: `${process.env.VUE_APP_ROOT}/documents/uploadRevision/${document_id}`,
      data: myForm,
      headers: authFileHeader(),
    });
  }

  delDoc(document_id) {
    return axios({
      method: "delete",
      url: `${process.env.VUE_APP_ROOT}/documents/delete/${document_id}`,
      headers: authHeader(),
    });
  }

  resetPassword(reference) {
    var myForm = new FormData();
    myForm.append("email", (" " + reference + " ").trim());

    return axios({
      method: "post",
      url: `${process.env.VUE_APP_ROOT}/users/request-reset-password.json`,
      data: myForm,
      headers: authFileHeader(),
    });
  }
  async changePassword(myForm, user_id, token) {
    //Gestisco questo perchè posso avere il token in get
    let h = {};
    if (token !== undefined) {
      h = { Authorization: "Bearer " + token };
    } else {
      h = authHeader();
    }

    return axios({
      method: "post",
      url: `${process.env.VUE_APP_ROOT}/users/change-password/${user_id}.json`,
      data: myForm,
      headers: h,
    });
  }
}

export default new UserService();
